import _ from 'underscore';

angular.module('am4').directive('progressBar', () => {
    return {
        restrict: 'E',
        bindToController: {
            percent: '=',
            eta: '=?',
            theme: '@?',
            errorCondition: '=?',
            errorMessage: '@?'
        },
        transclude: true,
        controllerAs: 'progressBarCtrl',
        template: require('./progressBar.html'),
        controller: function($scope, $element, $timeout, $window) {
            this.themeClass = this.theme ? 'am4-progress-bar--' + this.theme : '';
            const onResize = () => {
                    this.width = $element.find('.am4-progress-bar__bar').width();
                },
                onResizeDebounce = _.throttle(() => {
                    onResize();
                    $scope.$apply();
                }, 300);

            $scope.$watch(() => this.eta, eta => {
                this.seconds = Math.floor(eta) % 60;
                this.minutes = Math.floor(eta / 60);
            });

            $timeout(onResize);

            angular.element($window).bind('resize', onResizeDebounce);

            // Clean up open progress bar removed from page
            $scope.$on('$destroy', () => {
                angular.element($window).unbind('resize', onResizeDebounce);
            });
        }
    };
});



// WEBPACK FOOTER //
// ./src/app/directives/progressBar.js